import React from "react";
import "./Contact.css";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaWhatsapp,
  FaInstagram,
  FaGithub,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6"; // 🆕 Import X (Twitter) icon

const Contact = () => {
  return (
    <section id="contact" className="contact-section">
      <div className="container">
        {/* Section Title */}
        <div className="section-header">
          <h2>Contact Me</h2>
        </div>

        <div className="contact-row">
          {/* Need Service Form */}
          <div className="contact-card">
            <div className="card-body">
              <form
                action="https://formsubmit.co/lokeshlanka24@gmail.com"
                method="POST"
              >
                <h2>Need Service ?</h2>

                <label htmlFor="name">Full Name:</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Enter Full Name.."
                  required
                />

                <label htmlFor="mail">Mail Id:</label>
                <input
                  type="email"
                  id="mail"
                  name="email"
                  placeholder="Enter E-mail.."
                  required
                />

                <label htmlFor="contact">Phone No:</label>
                <input
                  type="tel"
                  id="contact"
                  name="number"
                  placeholder="Enter Phone Num.."
                  required
                />

                <label htmlFor="subject">Subject:</label>
                <textarea
                  id="subject"
                  name="subject"
                  placeholder="Write something.."
                  required
                />

                {/* hidden fields */}
                <input type="hidden" name="_captcha" value="false" />
                <input
                  type="hidden"
                  name="_next"
                  value="https://yourdomain.com/thankyou"
                />

                <button type="submit" className="submit-btn">
                  Submit
                </button>
              </form>
            </div>
          </div>

          {/* Social Media Links */}
          <div className="contact-card social-card">
            <div className="card-body follow-card">
              <h2 className="follow-center">Follow Me</h2>
              <div className="orbit">
                <a
                  href="https://www.facebook.com/Lokeshlanka24?mibextid=ZbWKwL"
                  target="_blank"
                  rel="noreferrer"
                  className="icon fb"
                >
                  <FaFacebookF />
                </a>

                <a
                  href="https://www.linkedin.com/in/lokesh-lanka-2ab18818a"
                  target="_blank"
                  rel="noreferrer"
                  className="icon li"
                >
                  <FaLinkedinIn />
                </a>

                <a
                  href="https://wa.me/your-number"
                  target="_blank"
                  rel="noreferrer"
                  className="icon wa"
                >
                  <FaWhatsapp />
                </a>

                <a
                  href="https://instagram.com/find_me_anywhere_mr.24?igshid=ZDdkNTZiNTM="
                  target="_blank"
                  rel="noreferrer"
                  className="icon ig"
                >
                  <FaInstagram />
                </a>

                <a
                  href="https://github.com/Loki-24"
                  target="_blank"
                  rel="noreferrer"
                  className="icon gh"
                >
                  <FaGithub />
                </a>

                {/* 🆕 X (Twitter) icon */}
                <a
                  href="https://x.com/Lokeshlanka24"
                  target="_blank"
                  rel="noreferrer"
                  className="icon tw"
                >
                  <FaXTwitter />
                </a>
              </div>
            </div>
          </div>

          {/* Hire Me Form */}
          <div className="contact-card">
            <div className="card-body">
              <form
                action="https://formsubmit.co/lokeshlanka24@gmail.com"
                method="POST"
              >
                <h2>Hire Me</h2>

                <label htmlFor="company">Company Name:</label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  placeholder="Enter Company Name.."
                  required
                />

                <label htmlFor="hire-mail">Mail Id:</label>
                <input
                  type="email"
                  id="hire-mail"
                  name="email"
                  placeholder="Enter E-mail.."
                  required
                />

                <label htmlFor="hire-contact">Phone No:</label>
                <input
                  type="tel"
                  id="hire-contact"
                  name="number"
                  placeholder="Enter Contact Num.."
                  required
                />

                <label htmlFor="hire-subject">Subject:</label>
                <textarea
                  id="hire-subject"
                  name="subject"
                  placeholder="Write something.."
                  required
                />

                {/* hidden fields */}
                <input type="hidden" name="_captcha" value="false" />
                <input
                  type="hidden"
                  name="_next"
                  value="https://yourdomain.com/thankyou"
                />

                <button type="submit" className="submit-btn">
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
